import React, { useContext, useState } from "react";
import { Text, View, StatusBar } from "react-native";
import { useNavigation, NavigationContainer } from "@react-navigation/native";
import { Feather as Icons, FontAwesome5 } from "@expo/vector-icons";

import {
  Container,
  Content,
  ContainerInfoDelivery,
  Header,
  IconFE,
  Title,
  CardDetails,
  IconFA5,
  ContentTitleCard,
  OrderName,
  ContentRecipient,
  DataDelivery,
  TitleInfoDelivey,
  CardActions,
  CenterOrderActions,
  ContainerActions,
  ContentDates,
  DeliveryStatus,
  OrderActions,
  TextActions,
  ButtonFinalizeDelivery,
  TextFinalizeDelivery,
} from "./styles";
import { Button } from "../../../components";
import styled from "styled-components";
import { themes } from "../../../design/colors";
import UserContext from "../../../context/user";
import RouteContext from "../../../context/route";

function DetailsDeliveryAdmin() {
  const navigation = useNavigation();
  const { individualOrder, reportProblem, loading } = useContext(RouteContext);
  const dateOrder = new Date(individualOrder.date_order);

  function backPage() {
    navigation.goBack();
  }

  function handleReportProblem() {
    navigation.navigate("ReportProblemDriver");
  }

  function handleViewProblem() {
    navigation.navigate("ViewProblemDriver");
  }

  function handleConfirmDelivery() {
    navigation.navigate("ConfirmDeliveryDriver");
  }

  async function handleFinalizeDelivery() {
    await reportProblem(individualOrder.id);
  }

  return (
    <Container>
      <Header>
        <IconFE name="arrow-left" size={25} color="#fff" onPress={backPage} />
        <Title>Detalhes da encomenda</Title>
        <View />
      </Header>

      <Content>
        <CardDetails>
          <ContentTitleCard>
            <IconFA5
              name="shipping-fast"
              size={25}
              color={themes.colors.primary}
            />
            <OrderName>Informações da entrega</OrderName>
          </ContentTitleCard>

          <ContentRecipient>
            <TitleInfoDelivey>DESTINATÁRIO</TitleInfoDelivey>
            <DataDelivery>{individualOrder.destiny_name}</DataDelivery>
          </ContentRecipient>

          <ContentRecipient>
            <TitleInfoDelivey>ENDEREÇO DE ENTREGA</TitleInfoDelivey>
            <DataDelivery>{`${individualOrder.destiny_address}, ${individualOrder.destiny_address_number}, ${individualOrder.destiny_city} - ${individualOrder.destiny_state}`}</DataDelivery>
          </ContentRecipient>

          <ContentRecipient>
            <TitleInfoDelivey>Número da nota</TitleInfoDelivey>
            <DataDelivery>{individualOrder.invoice_number}</DataDelivery>
          </ContentRecipient>
        </CardDetails>

        <DeliveryStatus>
          <ContentTitleCard>
            <IconFE name="calendar" size={25} color={themes.colors.primary} />
            <OrderName>Situação da entrega</OrderName>
          </ContentTitleCard>

          <ContentRecipient>
            <TitleInfoDelivey>STATUS</TitleInfoDelivey>
            <DataDelivery>{individualOrder.status_name}</DataDelivery>
          </ContentRecipient>

          <ContentDates>
            <View>
              <TitleInfoDelivey>DATA DE ENTREGA</TitleInfoDelivey>
              <DataDelivery>
                {individualOrder.order_status === 1
                  ? dateOrder.toLocaleDateString()
                  : "--/--/----"}
              </DataDelivery>
            </View>
          </ContentDates>
        </DeliveryStatus>

        <ContainerActions>
          {individualOrder.order_status === 0 && (
            <OrderActions>
              <CardActions onPress={handleReportProblem}>
                <IconFE
                  name="x-circle"
                  size={25}
                  color="#E74040"
                  style={{ textAlign: "center" }}
                />
                <TextActions>Informar</TextActions>
                <TextActions>Problema</TextActions>
              </CardActions>
            </OrderActions>
          )}

          {individualOrder.order_status !== 0 && (
            <CenterOrderActions>
              <CardActions onPress={handleViewProblem}>
                {individualOrder.order_status === 1 ? (
                  <IconFE
                    name="check-circle"
                    size={25}
                    color={themes.colors.green0}
                    style={{ textAlign: "center" }}
                  />
                ) : (
                  <IconFE
                    name="alert-circle"
                    size={25}
                    color="#E7BA40"
                    style={{ textAlign: "center" }}
                  />
                )}
                <TextActions>Visualizar</TextActions>
                {individualOrder.order_status === 1 && (
                  <TextActions>Comprovante</TextActions>
                )}
                {individualOrder.order_status === 2 && (
                  <TextActions>Problemas</TextActions>
                )}
              </CardActions>
            </CenterOrderActions>
          )}

          {individualOrder.order_status === 0 && (
            <OrderActions>
              <CardActions onPress={handleConfirmDelivery}>
                <IconFE
                  name="check-circle"
                  size={25}
                  color={themes.colors.green0}
                  style={{ textAlign: "center" }}
                />
                <TextActions>Scanear</TextActions>
                <TextActions>Entrega</TextActions>
              </CardActions>
            </OrderActions>
          )}
        </ContainerActions>
        {individualOrder.order_status === 0 && (
          <Button
            title="Finalizar"
            loading={loading}
            onPress={handleFinalizeDelivery}
          />
        )}
      </Content>
    </Container>
  );
}

export default DetailsDeliveryAdmin;
